import { render, staticRenderFns } from "./PremiumForbiddenAction.html?vue&type=template&id=4e5b9814&"
import script from "./PremiumForbiddenAction.js?vue&type=script&lang=js&"
export * from "./PremiumForbiddenAction.js?vue&type=script&lang=js&"
import style0 from "./PremiumForbiddenAction.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports